export type MfaRequestChannel = 'sms' | 'email';

export type MfaVerifyChannel = MfaRequestChannel | 'totp';

export type MfaScope =
  | 'AUTH'
  | 'CHANGE_AUTH_MODE'
  | 'CHANGE_PASSWORD'
  | 'CHANGE_PHONE_NUMBER'
  | 'CLOSE_ACCOUNT'
  | 'DELETE_PASSKEY'
  | 'DELETE_TOTP'
  | 'FIRST_REGISTER_PASSKEY'
  | 'RESET_PASSWORD'
  | 'REGISTER_PASSKEY'
  | 'REGISTER_PHONE_NUMBER'
  | 'REGISTER_TOTP'
  | 'WITHDRAWAL'
  | 'WITHDRAWAL_IN_WHITELIST_MODE'
  | 'WITHDRAWAL_ADDRESS_BOOK'
  | 'WITHDRAWAL_SETTING'
  | 'UPDATE_ANTI_PHISHING_CODE'
  | 'REGISTER_RETAIL_API_KEY'
  | 'MODIFY_RETAIL_API_KEY'
  | 'DELETE_RETAIL_API_KEY'
  | 'AUTH_REQUEST_SMS'
  | 'AUTH_REQUEST_TOTP';

export const WithdrawalBlockMfaScopes = [
  'CHANGE_PASSWORD',
  'CHANGE_PHONE_NUMBER',
  'DELETE_TOTP',
  'RESET_PASSWORD',
  'REGISTER_PHONE_NUMBER',
  'REGISTER_TOTP',
] as const;

export interface PostMfaInitiateParams {
  passkeyAvailable: boolean;
  mfaScope: MfaScope;
  authToken?: string;
  email?: string;
  passwordResetToken?: string;
  authRequestId?: string;
}

export interface PostMfaInitiateResponse {
  requirePasskey: boolean;
  requireTotp: boolean;
  requireSms: boolean;
  requireEmail: boolean;
  mfaSessionToken: string;
  mfaSessionExpiresAt: string;
}

export interface PostMfaRequestParams {
  mfaSessionToken?: string;
  // TODO: [sh] 전체 전환 후 required로 변경
  mfaScope?: MfaScope;
  action?: string;
  channel: MfaVerifyChannel;
  overrideSession?: boolean;
  authToken?: string;
  email?: string;
  passwordResetToken?: string;
  resetChannel?: boolean;
  context?: {
    withdrawalRequestId?: string;
    accountClosure?: boolean;
  };
  authRequestId?: string;
}

export interface PostMfaRequestResponse {
  mfaSessionToken?: string;
  mfaSessionExpiresAt: string;
  channelTokenLength: number;
  channelTokenExpiresAt: string;
  channelTokenDurationSec: number;
}

export interface PostMfaVerifyParams {
  mfaSessionToken?: string;
  // TODO: [sh] 전체 전환 후 required로 변경
  mfaScope?: MfaScope;
  authToken?: string;
  smsToken?: string;
  emailToken?: string;
  totpToken?: string;
  overrideSession?: boolean;
  email?: string;
  passwordResetToken?: string;
  authRequestId?: string;
}

export interface PostMfaVerifyResponse {
  mfaSessionToken: string;
  mfaSessionExpiresAt: string;
}

export interface GetMfaStatusParams {
  email?: string;
  passwordResetToken?: string;
}

export interface GetMfaStatusResponse {
  hasTotp: boolean;
  hasSms: boolean;
  hasChangedTotp: boolean;
  hasChangedSms: boolean;
}

export interface PostMfaTotpSecretResponse {
  secretKey: string;
  compatibleUri: string;
}

export interface PostMfaEnableParams {
  mfaSessionToken: string;
}

export interface PostMfaPasskeyAuthResponse {
  mfaSessionToken: string;
  mfaSessionExpiresAt: string;
}

export interface PostMfaPasskeyAuthParams {
  body: {
    id: string;
    rawId: string;
    type: string;
    authenticatorAttachment: string;
    response: {
      clientDataJSON: string;
      authenticatorData: string;
      signature: string;
    };
  };
  authMethod?: string;
  mfaSessionToken?: string;
  mfaScope?: MfaScope;
  authToken?: string;
  overrideSession?: boolean;
  decodeChallenge?: boolean;
  context?: {
    withdrawalRequestId?: string;
    accountClosure?: boolean;
  };
}
